import { createSlice } from "@reduxjs/toolkit";

const initialDateAvailability = {
  availability: []
}

const availabilitySlice = createSlice({
  name: "availability",
  initialState: {
    bookingDialogAvailability: initialDateAvailability,
    isBookingDialogAvailabilityLoading: false,
    bookingDialogError: null,
  },
  reducers: {
    getBookingAvailability: (state,) => {
      state.isBookingDialogAvailabilityLoading = true;
    },
    getBookingAvailabilitySuccess: (state, action) => {
      state.bookingDialogAvailability = action.payload.data;
      state.isBookingDialogAvailabilityLoading = false;
    },
    getBookingAvailabilityFailure: (state, action) => {
      state.isBookingDialogAvailabilityLoading = false;
      state.bookingDialogError = action.payload
    },
    resetBookingAvailabilityParams: state => {
      state.bookingDialogAvailability = initialDateAvailability;
    },
  }
});

export const {
  getBookingAvailability,
  getBookingAvailabilitySuccess,
  getBookingAvailabilityFailure,
  resetBookingAvailabilityParams,
} = availabilitySlice.actions;

export default availabilitySlice.reducer;
